import { IconButton, TextButton, Tooltip } from '@ds';
import React from 'react';
import { DSDownloadIcon } from '@ds-icons';

interface DownloadReportButtonProps {
  onDownload: () => void;
  shouldDisplayText?: boolean;
}

const DownloadReportButton = ({
  onDownload,
  shouldDisplayText
}: DownloadReportButtonProps) => {
  return (
    <>
      {shouldDisplayText ? (
        <TextButton
          onClick={onDownload}
          type="secondary"
          PrefixIcon={<DSDownloadIcon />}
        >
          Download
        </TextButton>
      ) : (
        <Tooltip content="Download" placement="bottom" arrow={false}>
          <IconButton
            onClick={onDownload}
            Icon={<DSDownloadIcon />}
            type="secondary"
          />
        </Tooltip>
      )}
    </>
  );
};
export default DownloadReportButton;
